import { useAccount, useMsal } from "@azure/msal-react";
import { useQuery } from "@tanstack/react-query";
import { getAPI } from "src/utils/fetch";

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;

interface UserInfo {
    id: string;
    org_code: string;
    email: string;
    roles: string[];
    user_preferences: UserPreferences;
}

interface Message {
    content: string;
    level: string;
    id: string;
}

export interface Datasource {
    id: string;
    name: string;
    description: string;
    product_line_filter: string[];
    has_access: boolean;
}

export interface Organization {
    id: string;
    product_lines: string[];
    description: string;
}

export interface UserResponse {
    info: UserInfo;
    messages: Message[];
    datasources: Datasource[];
    organizations: Organization[];
}

export type UserPreferences = {
    datasources: string[];
    product_line: string;
    memory_enabled: boolean;
};

export const useUser = () => {
    const { instance } = useMsal();
    const account = useAccount();
    const isAuthenticated = !!account?.idToken;

    return useQuery<UserResponse, Error>({
        queryKey: ["user"],
        queryFn: async () => {
            const response = await getAPI({
                url: `${BACKEND_URL}/v1/user`,
                instance,
            });
            const data = await response.json();
            return data;
        },
        enabled: isAuthenticated,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
    });
};
